import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_ecjcctkpm8: FaireBrandEntity = {
  token: "b_ecjcctkpm8",
  type: "brand",
  name: "Clean+Kind",
  avatarUrl:
    "https://cdn.faire.com/fastly/4e22556d6d803f2b73eba2e2fc580204568fd0650a5bc31bc930b98a202da641.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/fa1ee9859a905cdfaee6f206401907ab0c44d40dab71f68cb3cca92139ed714f.png",
  logoUrl:
    "https://cdn.faire.com/fastly/4e22556d6d803f2b73eba2e2fc580204568fd0650a5bc31bc930b98a202da641.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/fa1ee9859a905cdfaee6f206401907ab0c44d40dab71f68cb3cca92139ed714f.png",
  location: "Royal Oak, MI, USA",
  minimumOrderDollars: 83,
  rating: 5,
  reviewCount: 3,
  isTopShop: true,
  isInsider: true,
  description:
    "Skincare for People Who Check the Ingredients First. All of our Products are formulated and made in house with a high cleanliness score in mind - 95 Average. Founded in 2022, Clean + Kind is dedicated to mindful skincare, curated with care. We blend thoughtfully selected ingredients into clean, gentle formulas designed to nourish, hydrate, and support naturally radiant skin. Our commitment to purity ensures kindness to your skin—and the planet.",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:52:32.154Z",
    importedBy: "entity-db-cli",
  },
};
